import React from "react";
import ReactDOM from "react-dom";
import "./FullScreenLoader.css";

const FullScreenLoader = ({ show }) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="fullscreen-loader">
      <div className="loader-box">
        <div className="spinner"></div>
          <p>Processing your request...</p>
      </div>
    </div>,
    document.body
  );
};

export default FullScreenLoader;